export enum ValidationErrorMessageCode {
  "INVALID_SECURITY_QUESTION_ANSWER" = "invalid_security_question_answer",
  "INVALID_PASSWORD" = "invalid_password",
  "AWS_TOKEN_EXPIRED" = "aws_marketplace_token_expired",
  "MARKETPLACE_ACCOUNT_PROVISIONED" = "aws_marketplace_account_id_already_used_account_provisioned",
  "MARKETPLACE_ACCOUNT_NOT_PROVISIONED" = "aws_marketplace_account_id_already_used_account_not_provisioned",
}

export interface ValidationErrorMessage {
  error: {
    code: ValidationErrorMessageCode;
    message: string;
  };
}

export class HttpBadRequestError extends Error {
  status: number;
  errorMessage: Promise<ValidationErrorMessage>;

  constructor(public response: Response) {
    super("HttpBadRequestError");

    this.status = response.status;
    this.errorMessage = response.json();
  }
}
